import { render } from "./PublicResetPassword.vue?vue&type=template&id=c2d7604a&scoped=true"
import script from "./PublicResetPassword.vue?vue&type=script&lang=js"
export * from "./PublicResetPassword.vue?vue&type=script&lang=js"

import "./PublicResetPassword.vue?vue&type=style&index=0&id=c2d7604a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d7604a"]])

export default __exports__